export default __webpack_public_path__ + "static/media/editeurs-01.768cfc59.jpg";